import { AlertColorType } from "@/lib/main";
import { CSSProperties } from "react";

type FormStyleType = {
  value: string;
  isFocused: boolean;
  alertColor?: AlertColorType;
  disabled?: boolean;
};

const formStyle = ({
  value,
  isFocused,
  alertColor,
  disabled,
}: FormStyleType): CSSProperties => {
  const styles: CSSProperties = {
    backgroundColor: "var(--color-background-frame)",

    border: `var(--border-width-sm) solid var(--color-border-${
      disabled
        ? "subtle"
        : alertColor === "danger"
          ? "danger"
          : isFocused
            ? "focus"
            : "quaternary"
    })`,
    borderRadius: "var(--border-radius-sm)",

    width: "100%",

    // TODO: disabled color not working for placeholder
    color: `var(--color-text-${
      disabled ? "disabled" : value === "" ? "tertiary" : "primary"
    })`,
    // must be at least 16px to prevent zoom on iOS
    fontSize: "var(--font-size-sm)",
    fontWeight: value === "" ? 400 : 500,
  };
  return styles;
};

export default formStyle;
